const copy = {
  buttonText: (displayName: string) => `Provide ${displayName} feedback`,
  defaultButtonText: "Provide feedback",
};

export default copy;
